// extracted by mini-css-extract-plugin
export default {"AppLoadingScreen":"AppLoadingScreen_AppLoadingScreen__6kTMB","animation":"AppLoadingScreen_animation__IQG-g"};